<template>
<div class="hideme">
	<div class="voters-outer">
		<div class="voters-wrapper">
			<div class="voters-inner clearfix">
				<a href="http://www.foxsearchlight.com/fyc/film/three-billboards-outside-ebbing-missouri/find-a-screening/" target="_blank">
					<div class="voters-container col-xs-12">
						<div class="voters-middle">FIND A SCREENING</div>
					</div>
				</a>
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'voters'
}

</script>


// WEBPACK FOOTER //
// Voters.vue?24ff16fe